export default "__VITE_ASSET__987eb3a9__"